module.exports = __webpack_public_path__ + "assets/img/s5-tab-4-182b57b8.png";